(function () {
  if (window.__customContentV2Bound) return;
  window.__customContentV2Bound = true;

  function syncSection(section) {
    const imageWrapper = section.querySelector('[data-cc-v2-role="image"]');
    if (!imageWrapper) {
      section.style.removeProperty('--cc-v2-match-height');
      return;
    }
    const h = imageWrapper.getBoundingClientRect().height;
    if (h > 0) {
      section.style.setProperty('--cc-v2-match-height', `${Math.round(h)}px`);
    }
  }

  function initAll() {
    document.querySelectorAll('.section--custom-content-v2[data-match-height]').forEach((section) => {
      syncSection(section);
      const imageWrapper = section.querySelector('[data-cc-v2-role="image"]');
      if (imageWrapper && typeof ResizeObserver !== 'undefined') {
        const ro = new ResizeObserver(() => syncSection(section));
        ro.observe(imageWrapper);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.addEventListener('load', initAll);
  window.addEventListener('resize', () => {
    document.querySelectorAll('.section--custom-content-v2[data-match-height]').forEach(syncSection);
  });
})();
